module.exports = __webpack_public_path__ + "img/pilot.be5030ca.webp";